export default __webpack_public_path__ + "static/media/ceil~beyOOqCY.2a1d4165.svg";